/* global location, URL */
const $ = jQuery.noConflict();
export default function deviceMenu() {
    $(() => {
        const $hamBurger = $('.hamburger');
        const $overlay = $('.mbnav__backdrop');

        function menuClose() {
            $hamBurger.removeClass('is-clicked');
            $('body').removeClass('scroll-fixed');
            $('.mbnav').removeClass('is-open');
            $('.mbnav .menu-wrap li').removeClass('is-open');
            $('.mbnav__inner > .menu-wrap').css('--leftSlide', '0');
            $('.mbnav .hamburger').removeClass('is-clicked');
            $('header.main-header').removeClass('is-open');
        }

        $('.main-footer').click(function() {
            $('.main-header .hamburger').addClass('is-clicked');
        });

        // Close menu when clicking outside
        $overlay.click(function() {
            menuClose();
        });

        // Toggle hamburger
        $hamBurger.click(function() {
            if ($(this).hasClass('is-clicked')) {
                menuClose();
            } else {
                $(this).addClass('is-clicked');
                $('.mbnav').addClass('is-open');
                $('body').addClass('scroll-fixed');
                $('.mbnav .hamburger').addClass('is-clicked');
                $('header.main-header').addClass('is-open');
                updateMenuPadding(); // ensure padding is updated on open
            }
        });

        // Structure wrapping
        $('.mbnav__inner > *').wrapAll(
            '<div class="menu-wrap"><div class="menu-inner"></div></div>',
        );

        const updateMenuPadding = () => {
            const headerHeight = $('header.main-header').outerHeight();
            $('.mbnav .menu-wrap > .menu-inner').css('padding-top', headerHeight);
        };

        updateMenuPadding();
        $(window).resize(updateMenuPadding);
        $(window).on('scroll', updateMenuPadding);

        $('.mbnav a[href*="#"]').on('click', function(e) {
            const linkHref = $(this).attr('href');
            const currentHost = location.hostname;
            const currentPath = location.pathname;

            const url = new URL(linkHref, location.origin);

            if (
                url.hostname === currentHost &&
                url.pathname === currentPath &&
                url.hash
            ) {
                e.preventDefault();
                const $target = $(url.hash);

                if ($target.length) {
                    const offset = $('header.main-header').outerHeight();
                    $('html, body').animate(
                        {
                            scrollTop: $target.offset().top - offset,
                        },
                        500,
                        () => {
                            menuClose();
                        },
                    );
                } else {
                    menuClose();
                }
            } else {
                menuClose();
            }
        });
    });
}

